/**
 * 新增class
 * @param domString
 * @param className
 * @returns
 */
export const addClass = function (domString, className) {
  try {
    if (!domString || !document.querySelector(domString)
    || document.querySelector(domString).className.includes(className)) {
      return;
    };
    document.querySelector(domString).classList.add(className);
  } catch (e) {
    console.log('addClass不支持', e);
  }
};

/**
 * 移除class
 * @param domString
 * @param className
 * @returns
 */
export const removeClass =  function (domString, className) {
  try {
    if (!domString || !document.querySelector(domString)
    || !document.querySelector(domString).className.includes(className)) {
      return;
    };
    document.querySelector(domString).classList.remove(className);
  } catch (e) {
    console.log('removeClass不支持', e);
  }
};
